import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { Assets } from '../../../types/kpis';
import { usePreferences } from '../../../hooks/preferences';

interface Data {
  value: Assets;
  label: string;
}

interface Disabled {
  roads: boolean;
  trucks: boolean;
  drills: boolean;
}

interface ICustomTabProps {
  initialValue?: Assets;
  disabled?: Disabled;
  data: Data[];
}

const CustomTabBar: React.FC<ICustomTabProps> = ({
  initialValue,
  disabled,
  data,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectDataType, dataType } = usePreferences();
  const [tabValue, setTabValue] = useState<Assets>(initialValue || 'roads');

  const handleChangeTab = (event: any, newValue: Assets): void => {
    selectDataType(newValue);
  };

  useEffect(() => {
    setTabValue(dataType);
  }, [dataType]);

  return (
    <AppBar position="fixed" elevation={0} className={classes.appBar}>
      <Toolbar disableGutters className={classes.header}>
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          onChange={handleChangeTab}
          aria-label={t('components:nav.assetsSelectorAria')}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#7030A0',
              height: 4,
              bottom: 4,
            },
          }}
        >
          {data.map(dt => (
            <Tab
              key={dt.value}
              label={dt.label}
              disabled={disabled && disabled[dt.value]}
              className={classes.tab}
              selected={tabValue === dt.value}
              value={dt.value}
            />
          ))}
        </Tabs>
      </Toolbar>
    </AppBar>
  );
};

export default CustomTabBar;
